import PhotoGallery from './PhotoGallery';

export default PhotoGallery;
